import "core-js/modules/es.array.sort.js";
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from "react";
import { locales } from "./localization";
var PageTranslationsContext = /*#__PURE__*/React.createContext({});
export var PageTranslationsProvider = function PageTranslationsProvider(param) {
  var path = param.path,
    language = param.language,
    localizations = param.localizations,
    children = param.children;
  var mappedLocalizations = new Map();
  localizations === null || localizations === void 0 ? void 0 : localizations.forEach(function (value) {
    mappedLocalizations.set(value.locale, value.path);
  });
  return /*#__PURE__*/React.createElement(PageTranslationsContext.Provider, {
    value: mappedLocalizations || translationPaths(path, language, Object.keys(locales))
  }, children);
};
export var usePageTranslations = function usePageTranslations() {
  return useContext(PageTranslationsContext);
};
/**
 * @deprecated
 */
export function addPageTranslations(items) {
  return items.map(function (item) {
    return _object_spread_props(_object_spread({}, item), {
      translations: items.filter(function (trans) {
        return trans.drupalId === item.drupalId;
      }).sort(function (a, b) {
        return a.langcode > b.langcode ? 1 : -1;
      }).map(function (item) {
        return _define_property({}, item.langcode || "de", (item === null || item === void 0 ? void 0 : item.path) || "/".concat(item.drupalId));
      }).reduce(function (acc, val) {
        return Object.assign({}, acc, val);
      }, {})
    });
  });
}
export function translationPaths(path, currentLanguage, languages) {
  return path ? languages.map(function (lang) {
    return _define_property({}, lang, path.replace("/".concat(currentLanguage), "/".concat(lang)));
  }).reduce(function (acc, val) {
    return Object.assign({}, acc, val);
  }, {}) : {};
}